export function formatDateTime(dateInput, showTime = false) {
    let date;
    // Firestore Timestamp
    if (dateInput && typeof dateInput.toDate === 'function') {
      date = dateInput.toDate();
    }
    // JS Date
    else if (dateInput instanceof Date) {
      date = dateInput;
    }
    // Timestamp in milliseconds
    else if (typeof dateInput === 'number') {
      date = new Date(dateInput);
    }
    // String date
    else if (typeof dateInput === 'string') {
      date = new Date(dateInput);
    }
    else {
      return '';
    }
  
    const options = {
      timeZone: 'Asia/Kolkata',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    };
  
    if (showTime) {
      options.hour = '2-digit';
      options.minute = '2-digit';
      options.hour12 = true;
    }
  
    return date.toLocaleString('en-IN', options);
  }
  